import { TYPE_COLLECTION } from './input-types';
import { SHIP_FROM } from '../constants';

export const id = SHIP_FROM;
export const apiKey = 'ShipFromId';
export const legacyApiKey = 'warehouseId';
export const type = TYPE_COLLECTION;

export const shipFrom = {
  id,
  apiKey,
  type,
  legacyApiKey,
};
